import {CandidateDocsItem, DocRow} from "../../../assets/types/dtoTypes";

export function guessContentType(filename?: string | null): string | null {
  if (!filename) return null;
  const lower = filename.toLowerCase();
  if (lower.endsWith('.pdf')) return 'application/pdf';
  if (lower.endsWith('.doc') || lower.endsWith('.docx')) {
    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }
  return null;
}

export function findOriginalUpdatedAt(d: CandidateDocsItem): string | null {
  for (const b of d.bundles || []) {
    const orig = b.files?.find(f => f.kind === 'ORIGINAL' && !!f.updatedAt);
    if (orig?.updatedAt) return orig.updatedAt;
  }
  return null;
}

export function mapDocRows(d: CandidateDocsItem): DocRow[] {
  const rows: DocRow[] = [];

  rows.push({
    kind: 'ORIGINAL',
    name: d.originalFileName,
    url: d.originalSasUrl,
    contentType: guessContentType(d.originalFileName) ?? 'application/pdf',
    when: findOriginalUpdatedAt(d),
    label: 'Uploaded',
  });

  d.bundles?.forEach(b =>
    b.files
      ?.filter(f => f.kind === 'TRANSLATED' && !!f.sasUrl)
      .forEach(f =>
        rows.push({
          kind: 'TRANSLATED',
          name: f.name,
          url: f.sasUrl,
          contentType: f.contentType || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          when: f.updatedAt ?? null,
          label: 'Translated',
        }),
      ),
  );

  d.bundles?.forEach(b =>
    b.files?.forEach(f => {
      const isSigned = f.kind === 'SIGNED' || (f.path || '').toLowerCase().includes('/signed/');
      if (isSigned && f.sasUrl) {
        rows.push({
          kind: 'SIGNED',
          name: f.name,
          url: f.sasUrl,
          contentType: f.contentType || 'application/pdf',
          when: f.updatedAt ?? null,
          label: 'Verified',
        });
      }
    }),
  );

  return rows;
}
